import { render } from "./LegendInfo.vue?vue&type=template&id=6ca3f427&scoped=true"
import script from "./LegendInfo.vue?vue&type=script&lang=js"
export * from "./LegendInfo.vue?vue&type=script&lang=js"

import "./LegendInfo.vue?vue&type=style&index=0&id=6ca3f427&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ca3f427"]])

export default __exports__